import React, { useState, useEffect } from 'react';

// ux
import LoadingAnimationSimple from '../ux/LoadingAnimationSimple';

const FuseData = ({
  loadingData,
  brandName,
  celebrityName,
  predictedMediaMentions,
  predictedImpressions,
  avgMonthlyMentions,
  frequency,
  ignitionThrust,
  ignitionContext
}) => {
  const totalBars = 24;
  const [activeBars, setActiveBars] = useState(Array(totalBars).fill(false));
  const [fuseScore, setFuseScore] = useState('0%');
  const [scoreClass, setScoreClass] = useState('score');

  const fusion_media_mentions = predictedMediaMentions
    ? Math.round(Number(predictedMediaMentions)).toLocaleString('en-US')
    : 'N/A';
  const fusion_media_reach = predictedImpressions
    ? Math.round(Number(predictedImpressions)).toLocaleString('en-US')
    : 'N/A';
  const monthly_mentions = avgMonthlyMentions
    ? Math.round(Number(avgMonthlyMentions)).toLocaleString('en-US')
    : 'N/A';
  // frequency should only have one decimal place
  const frequency_formatted = frequency
    ? parseFloat(frequency).toFixed(1)
    : 'N/A';

  useEffect(() => {
    if (ignitionThrust) {
      const scoreNumber = ignitionThrust * 100;
      if (scoreNumber > 3000) {
        setFuseScore('30X+');
      } else if (scoreNumber > 500) {
        setFuseScore((scoreNumber / 100).toFixed(1) + 'X');
      } else {
        setFuseScore(Math.round(ignitionThrust * 100) + '%');
      }
    }
  }, [ignitionThrust]);

  useEffect(() => {
    if (ignitionContext) {
      const scoreCeiling = parseFloat(ignitionContext['Scale Ceiling']) || 100; // Default to 100 if undefined
      const scorePercentage = (ignitionThrust * 100 * 100) / scoreCeiling;
      const percentageIndex = Math.ceil((scorePercentage * totalBars) / 100);
      const updatedActiveBars = Array(totalBars)
        .fill(false)
        .map((_, index) => index < percentageIndex);
      setActiveBars(updatedActiveBars);

      if (updatedActiveBars.filter((bar) => bar).length < 6) {
        setScoreClass('fuse-score low');
      } else if (updatedActiveBars.filter((bar) => bar).length < 13) {
        setScoreClass('fuse-score mid-low');
      } else if (updatedActiveBars.filter((bar) => bar).length < 20) {
        setScoreClass('fuse-score mid-high');
      } else {
        setScoreClass('fuse-score high');
      }
    }
  }, [ignitionContext, ignitionThrust]);

  return (
    <>
      {loadingData ? (
        <div className="loading-animation-flex">
          <LoadingAnimationSimple />
        </div>
      ) : (
        <div className="fuselight-fuse-data">
          <div className="flex-container">
            <div className="monthly-mentions">
              <h3>Typical Monthly Mentions</h3>
              <p className="fuse-data">{monthly_mentions}</p>
            </div>
            <div className="fusion-lift">
              <p>Fusion lift</p>
            </div>
            <div className="media-mentions">
              <h3>Media Mentions</h3>
              <p className="fuse-data">{fusion_media_mentions}</p>
            </div>
            <div className="media-reach">
              <h3>Media Reach</h3>
              <p className="fuse-data">{fusion_media_reach}</p>
            </div>
            <div className="frequency">
              <h3>Frequency</h3>
              <p className="fuse-data">{frequency_formatted}</p>
            </div>
            <p className="score-description">
              A brand fusion between {brandName} and {celebrityName} should get
              you <span className={scoreClass}>{fuseScore}</span> more mentions
              than {brandName} usually gets monthly. Through the media outlets,
              this brand fusion will reach {fusion_media_reach} people.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default FuseData;
